// src/pages/Admin/StatistiquesComptabilite/data/comptaSections.js

import {
  FaChartLine,
  FaChartPie,
  FaCreditCard,
  FaShoppingBag,
} from "react-icons/fa";

export const COMPTA_SECTIONS = [
  {
    key: "statuts",
    id: "section-reglements-statuts",
    eyebrow: "Règlements",
    title: "Répartition des statuts de règlement",
    shortTitle: "Statuts",
    description:
      "Visualisez les dossiers réglés, en attente, partiels ou non renseignés.",
    icon: FaChartPie,
    defaultOpen: true,
  },
  {
    key: "types",
    id: "section-reglements-types",
    eyebrow: "Paiements",
    title: "Répartition des types de paiement",
    shortTitle: "Paiements",
    description:
      "Analyse des paiements par type : en ligne, chèque, espèces, virement, CB...",
    icon: FaCreditCard,
    defaultOpen: true,
  },
  {
    key: "achatsMensuels",
    id: "section-achats-mensuels",
    eyebrow: "Achats",
    title: "Évolution mensuelle des achats",
    shortTitle: "Mensuel",
    description:
      "Visualisez les pics d’achats mois par mois sur la saison sélectionnée.",
    icon: FaChartLine,
    defaultOpen: true,
  },
  {
    key: "boutique",
    id: "section-boutique",
    eyebrow: "Boutique",
    title: "Achats boutique par article",
    shortTitle: "Boutique",
    description: "Analyse des ventes boutique de la saison, hors acomptes.",
    icon: FaShoppingBag,
    defaultOpen: true,
  },
];

export function buildDefaultOpenSections() {
  return COMPTA_SECTIONS.reduce((acc, section) => {
    acc[section.key] = section.defaultOpen;
    return acc;
  }, {});
}